module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/Users/metasasha/metabase/security-releases/v0.46.6.1/node_modules/babel-loader/lib/index.js??ruleSet[1].rules[0].use[0]!/Users/metasasha/metabase/security-releases/v0.46.6.1/node_modules/source-map-loader/dist/cjs.js!/Users/metasasha/metabase/security-releases/v0.46.6.1/frontend/src/metabase-lib/metadata/utils/ga-metadata.js"));
    });
  });
}